/**
 * 🔴 Se entra SOLO por NIF. El correo dejó de valer aquí el 16-sep-2026, por decisión de
 * producto: un correo no identifica a una persona —se puede tener el corporativo y el
 * personal, y cambian al cambiar de empresa— y el NIF sí.
 *
 * Se manda siempre como `nif`, aunque lo que escriban lleve arroba: el backend ya no
 * resuelve por correo, así que mandarlo en un campo `email` sería pedirle algo que ya no
 * sabe hacer. A quien todavía no tiene NIF registrado le queda «¿Olvidaste tu contraseña?»,
 * que sí acepta correo y le deja dentro por enlace; su NIF llegará por el KYC.
 */
const login = async (identifier: string, password: string) => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/auth/login`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		// La contraseña no se recorta: puede llevar espacios a propósito.
		body: JSON.stringify({ nif: identifier.trim(), password })
	});

	return response.json();
};

export default login;
